import React from 'react';
import { useNavigate } from 'react-router-dom';
import SessionAndLoginHistorySection from '@/components/shared/Account/SessionAndLoginHistorySection';
import UIPageTitle from '@/components/shared/UIPageTitle';
import UIButton from '@/components/shared/UIButton';
import PreferencesSection from '@/components/shared/Account/PreferencesSection';
import './TenantAccountPage.scss';
import ChangePasswordSection from '@/components/shared/Account/ChangePasswordSection';
import GeneralSettingsSection from '@/components/shared/Account/GeneralSettingsSection';

import PersonalInformationSection from '@/components/shared/Account/PersonalnformationSection';
import TenantBillingInformationSection from '@/components/shared/Account/TenantBillingInformationSection';
import DocumentsSection from '@/components/shared/Account/DocumentsSection';
import { useDocuments } from '@/hooks/useDocuments';

const BackToHomeButton = () => {
  const navigate = useNavigate();
  return (
    <UIButton
      outline={true}
      variant="primary"
      size="medium"
      onClick={() => navigate('/')}
    >
      Back to Home
    </UIButton>
  );
};

const TenantAccountPage = () => {
  const {
    documents,
    loading,
    error,
    onUpload,
    onUpdate,
    onDelete,
  } = useDocuments();

  return (
    <>
      <UIPageTitle
        title="Account"
        action={<BackToHomeButton />}
      />

      <GeneralSettingsSection />

      <PersonalInformationSection />
      <TenantBillingInformationSection />
      <DocumentsSection
        documents={documents}
        onUpload={onUpload}
        onUpdate={onUpdate}
        onDelete={onDelete}
        loading={loading}
        error={error}
      />
      <ChangePasswordSection />
      <PreferencesSection
        initialValues={{
          language: 'en',
          timeZone: 'gmt+2',
          dateFormat: 'dd/mm/yyyy',
          defaultSetting: 'on',
          options: ['option1', 'option3'],
        }}
        onSave={(values) => console.log('Save:', values)}
        onClear={() => console.log('Clear')}
      />
      <SessionAndLoginHistorySection />
    </>
  );
};

export default TenantAccountPage;
